'use client';
import { JSX } from 'react';
import styles from '../buy-now-pay-later-options.module.scss';

interface ILearnHowLinkProps {
  toggleModal?: () => void;
  children?: string | JSX.Element;
  isProgressive?: boolean;
  id?: string;
}

export const LearnHowLink: React.FC<ILearnHowLinkProps> = ({
  toggleModal,
  children,
  isProgressive,
  id,
}) => {
  return (
    <button
      id={id}
      className={styles.buttonLink}
      tabIndex={0}
      aria-describedby={
        isProgressive ? 'buySectionHeading buySectionRight' : ''
      }
      aria-label="Learn How, Clickable dialog. "
      onClick={toggleModal}
    >
      {children}
    </button>
  );
};
